import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    icon:{

        '.lightTheme &':{
            backgroundColor:'var(--account-accent-soft, #EAF9FF)',
        },

        '.lightTheme &:hover':{
            backgroundColor:'var(--account-accent-tint, #2EBEFD)',
            '& .columnSvg':{
                fill:'#1E1E1E'
            }
        },


        transition:'all .3s',

    },
    item:{
        '.lightTheme &':{
            backgroundColor: '#f5f5f5',
            '&:hover':{
                backgroundColor:'var(--account-accent-tint, #bedcff)'
            },
            color:'#111',
        },
        borderRadius:'4px',

    }
}